import { Alert, AlertDescription } from '@/components/ui/alert';

/** The form-level message of a rejected create request (the API named no field). */
export function FormErrorAlert({ message }: { message: string | undefined }) {
  if (!message) return null;
  return (
    <Alert variant="destructive" className="px-3 py-2">
      <AlertDescription className="text-[13px]">{message}</AlertDescription>
    </Alert>
  );
}
